module.exports = __webpack_public_path__ + "static/media/Program18.a06455f5.jpg";